import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { WelcomeService } from '../../../services/welcome/welcome-service';

import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { WelcomeStep } from '../../../models/users/welcome/welcome-step';
import { CommunityService } from '../../../services/identity/community.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-widget-progress',
    templateUrl: './widget-progress.component.html',
    styleUrls: ['widget-progress.component.scss'],
})
export class WidgetProgressComponent implements OnInit, OnDestroy {
    @Input() public welcomePercentage!: number;
    public steps$: Observable<WelcomeStep[]>;

    private destroy$ = new Subject<void>();

    public numberOfStepsToShow: number = 3;
    public isLoading: boolean = true;

    constructor(
        private readonly welcomeService: WelcomeService,
        private readonly communityService: CommunityService,
        private readonly router: Router,
        private readonly translate: TranslateService,
    ) { }

    public async ngOnInit() {
        this.steps$ = this.welcomeService.steps$;
        this.isLoading = false;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public onAction(step: WelcomeStep) {
        step.action();
    }

    public goToWelcomePage() {
        this.router.navigate(['welcome']);
    }

    public openResource(step: WelcomeStep) {
        const resourceUrl = this.translate.instant(step.ressource);
        this.communityService.getOnboardingResource(resourceUrl)
            .pipe(takeUntil(this.destroy$))
            .subscribe((documentUrl) => window.open(documentUrl, '_blank'));
    }

    public getVisibleSteps(steps: WelcomeStep[]): WelcomeStep[] {
        return steps.filter(step => !step.completed).slice(0, this.numberOfStepsToShow);
    }
}
